/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginCallbackRouteImport } from './routes/login-callback'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedFavoritesRouteImport } from './routes/_authenticated/favorites'
import { Route as AuthenticatedCareerRouteImport } from './routes/_authenticated/career'
import { Route as AuthenticatedProfileIndexRouteImport } from './routes/_authenticated/profile/index'
import { Route as AuthenticatedJobsIndexRouteImport } from './routes/_authenticated/jobs/index'
import { Route as AuthenticatedCompaniesIndexRouteImport } from './routes/_authenticated/companies/index'
import { Route as AuthenticatedApplicationsIndexRouteImport } from './routes/_authenticated/applications/index'
import { Route as AuthenticatedProfileSeaServiceRouteImport } from './routes/_authenticated/profile/sea-service'
import { Route as AuthenticatedProfileReferencesRouteImport } from './routes/_authenticated/profile/references'
import { Route as AuthenticatedProfileDocumentsRouteImport } from './routes/_authenticated/profile/documents'
import { Route as AuthenticatedProfileCertificatesRouteImport } from './routes/_authenticated/profile/certificates'
import { Route as AuthenticatedJobsSlugRouteImport } from './routes/_authenticated/jobs/$slug'
import { Route as AuthenticatedCompaniesSlugRouteImport } from './routes/_authenticated/companies/$slug'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginCallbackRoute = LoginCallbackRouteImport.update({
  id: '/login-callback',
  path: '/login-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFavoritesRoute = AuthenticatedFavoritesRouteImport.update({
  id: '/favorites',
  path: '/favorites',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCareerRoute = AuthenticatedCareerRouteImport.update({
  id: '/career',
  path: '/career',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProfileIndexRoute =
  AuthenticatedProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJobsIndexRoute = AuthenticatedJobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCompaniesIndexRoute =
  AuthenticatedCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApplicationsIndexRoute =
  AuthenticatedApplicationsIndexRouteImport.update({
    id: '/applications/',
    path: '/applications/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileSeaServiceRoute =
  AuthenticatedProfileSeaServiceRouteImport.update({
    id: '/profile/sea-service',
    path: '/profile/sea-service',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileReferencesRoute =
  AuthenticatedProfileReferencesRouteImport.update({
    id: '/profile/references',
    path: '/profile/references',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileDocumentsRoute =
  AuthenticatedProfileDocumentsRouteImport.update({
    id: '/profile/documents',
    path: '/profile/documents',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileCertificatesRoute =
  AuthenticatedProfileCertificatesRouteImport.update({
    id: '/profile/certificates',
    path: '/profile/certificates',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJobsSlugRoute = AuthenticatedJobsSlugRouteImport.update({
  id: '/jobs/$slug',
  path: '/jobs/$slug',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCompaniesSlugRoute =
  AuthenticatedCompaniesSlugRouteImport.update({
    id: '/companies/$slug',
    path: '/companies/$slug',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/login-callback': typeof LoginCallbackRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/career': typeof AuthenticatedCareerRoute
  '/favorites': typeof AuthenticatedFavoritesRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/companies/$slug': typeof AuthenticatedCompaniesSlugRoute
  '/jobs/$slug': typeof AuthenticatedJobsSlugRoute
  '/profile/certificates': typeof AuthenticatedProfileCertificatesRoute
  '/profile/documents': typeof AuthenticatedProfileDocumentsRoute
  '/profile/references': typeof AuthenticatedProfileReferencesRoute
  '/profile/sea-service': typeof AuthenticatedProfileSeaServiceRoute
  '/applications/': typeof AuthenticatedApplicationsIndexRoute
  '/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/jobs/': typeof AuthenticatedJobsIndexRoute
  '/profile/': typeof AuthenticatedProfileIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/login-callback': typeof LoginCallbackRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/career': typeof AuthenticatedCareerRoute
  '/favorites': typeof AuthenticatedFavoritesRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/': typeof AuthenticatedIndexRoute
  '/companies/$slug': typeof AuthenticatedCompaniesSlugRoute
  '/jobs/$slug': typeof AuthenticatedJobsSlugRoute
  '/profile/certificates': typeof AuthenticatedProfileCertificatesRoute
  '/profile/documents': typeof AuthenticatedProfileDocumentsRoute
  '/profile/references': typeof AuthenticatedProfileReferencesRoute
  '/profile/sea-service': typeof AuthenticatedProfileSeaServiceRoute
  '/applications': typeof AuthenticatedApplicationsIndexRoute
  '/companies': typeof AuthenticatedCompaniesIndexRoute
  '/jobs': typeof AuthenticatedJobsIndexRoute
  '/profile': typeof AuthenticatedProfileIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/login-callback': typeof LoginCallbackRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_authenticated/career': typeof AuthenticatedCareerRoute
  '/_authenticated/favorites': typeof AuthenticatedFavoritesRoute
  '/_authenticated/notifications': typeof AuthenticatedNotificationsRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/companies/$slug': typeof AuthenticatedCompaniesSlugRoute
  '/_authenticated/jobs/$slug': typeof AuthenticatedJobsSlugRoute
  '/_authenticated/profile/certificates': typeof AuthenticatedProfileCertificatesRoute
  '/_authenticated/profile/documents': typeof AuthenticatedProfileDocumentsRoute
  '/_authenticated/profile/references': typeof AuthenticatedProfileReferencesRoute
  '/_authenticated/profile/sea-service': typeof AuthenticatedProfileSeaServiceRoute
  '/_authenticated/applications/': typeof AuthenticatedApplicationsIndexRoute
  '/_authenticated/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/_authenticated/jobs/': typeof AuthenticatedJobsIndexRoute
  '/_authenticated/profile/': typeof AuthenticatedProfileIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/login-callback'
    | '/register'
    | '/reset-password'
    | '/career'
    | '/favorites'
    | '/notifications'
    | '/settings'
    | '/companies/$slug'
    | '/jobs/$slug'
    | '/profile/certificates'
    | '/profile/documents'
    | '/profile/references'
    | '/profile/sea-service'
    | '/applications/'
    | '/companies/'
    | '/jobs/'
    | '/profile/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/login-callback'
    | '/register'
    | '/reset-password'
    | '/career'
    | '/favorites'
    | '/notifications'
    | '/settings'
    | '/'
    | '/companies/$slug'
    | '/jobs/$slug'
    | '/profile/certificates'
    | '/profile/documents'
    | '/profile/references'
    | '/profile/sea-service'
    | '/applications'
    | '/companies'
    | '/jobs'
    | '/profile'
  id:
    | '__root__'
    | '/_authenticated'
    | '/forgot-password'
    | '/login'
    | '/login-callback'
    | '/register'
    | '/reset-password'
    | '/_authenticated/career'
    | '/_authenticated/favorites'
    | '/_authenticated/notifications'
    | '/_authenticated/settings'
    | '/_authenticated/'
    | '/_authenticated/companies/$slug'
    | '/_authenticated/jobs/$slug'
    | '/_authenticated/profile/certificates'
    | '/_authenticated/profile/documents'
    | '/_authenticated/profile/references'
    | '/_authenticated/profile/sea-service'
    | '/_authenticated/applications/'
    | '/_authenticated/companies/'
    | '/_authenticated/jobs/'
    | '/_authenticated/profile/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  LoginCallbackRoute: typeof LoginCallbackRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login-callback': {
      id: '/login-callback'
      path: '/login-callback'
      fullPath: '/login-callback'
      preLoaderRoute: typeof LoginCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications': {
      id: '/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/favorites': {
      id: '/_authenticated/favorites'
      path: '/favorites'
      fullPath: '/favorites'
      preLoaderRoute: typeof AuthenticatedFavoritesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/career': {
      id: '/_authenticated/career'
      path: '/career'
      fullPath: '/career'
      preLoaderRoute: typeof AuthenticatedCareerRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/': {
      id: '/_authenticated/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthenticatedProfileIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/jobs/': {
      id: '/_authenticated/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof AuthenticatedJobsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/': {
      id: '/_authenticated/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AuthenticatedCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/applications/': {
      id: '/_authenticated/applications/'
      path: '/applications'
      fullPath: '/applications/'
      preLoaderRoute: typeof AuthenticatedApplicationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/sea-service': {
      id: '/_authenticated/profile/sea-service'
      path: '/profile/sea-service'
      fullPath: '/profile/sea-service'
      preLoaderRoute: typeof AuthenticatedProfileSeaServiceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/references': {
      id: '/_authenticated/profile/references'
      path: '/profile/references'
      fullPath: '/profile/references'
      preLoaderRoute: typeof AuthenticatedProfileReferencesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/documents': {
      id: '/_authenticated/profile/documents'
      path: '/profile/documents'
      fullPath: '/profile/documents'
      preLoaderRoute: typeof AuthenticatedProfileDocumentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/certificates': {
      id: '/_authenticated/profile/certificates'
      path: '/profile/certificates'
      fullPath: '/profile/certificates'
      preLoaderRoute: typeof AuthenticatedProfileCertificatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/jobs/$slug': {
      id: '/_authenticated/jobs/$slug'
      path: '/jobs/$slug'
      fullPath: '/jobs/$slug'
      preLoaderRoute: typeof AuthenticatedJobsSlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/$slug': {
      id: '/_authenticated/companies/$slug'
      path: '/companies/$slug'
      fullPath: '/companies/$slug'
      preLoaderRoute: typeof AuthenticatedCompaniesSlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedCareerRoute: typeof AuthenticatedCareerRoute
  AuthenticatedFavoritesRoute: typeof AuthenticatedFavoritesRoute
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedCompaniesSlugRoute: typeof AuthenticatedCompaniesSlugRoute
  AuthenticatedJobsSlugRoute: typeof AuthenticatedJobsSlugRoute
  AuthenticatedProfileCertificatesRoute: typeof AuthenticatedProfileCertificatesRoute
  AuthenticatedProfileDocumentsRoute: typeof AuthenticatedProfileDocumentsRoute
  AuthenticatedProfileReferencesRoute: typeof AuthenticatedProfileReferencesRoute
  AuthenticatedProfileSeaServiceRoute: typeof AuthenticatedProfileSeaServiceRoute
  AuthenticatedApplicationsIndexRoute: typeof AuthenticatedApplicationsIndexRoute
  AuthenticatedCompaniesIndexRoute: typeof AuthenticatedCompaniesIndexRoute
  AuthenticatedJobsIndexRoute: typeof AuthenticatedJobsIndexRoute
  AuthenticatedProfileIndexRoute: typeof AuthenticatedProfileIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCareerRoute: AuthenticatedCareerRoute,
  AuthenticatedFavoritesRoute: AuthenticatedFavoritesRoute,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedCompaniesSlugRoute: AuthenticatedCompaniesSlugRoute,
  AuthenticatedJobsSlugRoute: AuthenticatedJobsSlugRoute,
  AuthenticatedProfileCertificatesRoute: AuthenticatedProfileCertificatesRoute,
  AuthenticatedProfileDocumentsRoute: AuthenticatedProfileDocumentsRoute,
  AuthenticatedProfileReferencesRoute: AuthenticatedProfileReferencesRoute,
  AuthenticatedProfileSeaServiceRoute: AuthenticatedProfileSeaServiceRoute,
  AuthenticatedApplicationsIndexRoute: AuthenticatedApplicationsIndexRoute,
  AuthenticatedCompaniesIndexRoute: AuthenticatedCompaniesIndexRoute,
  AuthenticatedJobsIndexRoute: AuthenticatedJobsIndexRoute,
  AuthenticatedProfileIndexRoute: AuthenticatedProfileIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  LoginCallbackRoute: LoginCallbackRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
